import { GridColumns } from '@mui/x-data-grid-pro'
import { flatten } from 'ramda'
import { useMemo } from 'react'

import { AuthUserPermission, FieldModel } from '@cibo/core'
import { FieldColumnProps, useFieldColumns } from '@cibo/landmanager'
import { usePermissions } from '@cibo/profile'
import {
  FieldOpportunitiesColumnProps,
  FieldStatusColumnProps,
  useProgramColumns,
} from '@cibo/programs'

export const useColumnSets = (
  {
    onClickField,
    onClickNeedsInfo,
    onClickOpportunity,
    onClickEnrolling,
    onClickEngaged,
    onClickProgram,
  }: Pick<FieldOpportunitiesColumnProps, 'onClickNeedsInfo' | 'onClickOpportunity'> &
    Pick<FieldStatusColumnProps, 'onClickProgram' | 'onClickEnrolling' | 'onClickEngaged'> &
    Pick<FieldColumnProps, 'onClickField'> = {
    onClickOpportunity: console.log,
  }
) => {
  const { can } = usePermissions()

  const {
    fieldFarmColumn,
    fieldGrowerColumn,
    fieldIdentifierColumn,
    fieldUpdatedAtColumn,
  } = useFieldColumns({
    onClickField,
  })

  const { fieldStatusColumn, fieldOpportunitiesColumn } = useProgramColumns({
    onClickNeedsInfo,
    onClickOpportunity,
    onClickEnrolling,
    onClickEngaged,
    onClickProgram,
  })

  const growerColumnIfAllowed = can({ useAny: AuthUserPermission.GROWER_CONTACT_READ })
    ? [fieldGrowerColumn]
    : []
  const farmColumnIfAllowed = can({ useAny: AuthUserPermission.FARMS_VIEW })
    ? [fieldFarmColumn]
    : []

  const programStatusColumns = useMemo(
    () =>
      flatten<GridColumns<FieldModel>>([
        fieldIdentifierColumn,
        ...farmColumnIfAllowed,
        fieldStatusColumn,
        fieldOpportunitiesColumn,
        ...growerColumnIfAllowed,
        fieldUpdatedAtColumn,
      ]),
    []
  )

  const userFieldColumns = useMemo(
    () =>
      flatten<GridColumns<FieldModel>>([
        fieldIdentifierColumn,
        fieldStatusColumn,
        fieldOpportunitiesColumn,
        fieldUpdatedAtColumn,
      ]),
    []
  )

  return {
    programStatusColumns: programStatusColumns as GridColumns<FieldModel>,
    userFieldColumns: userFieldColumns as GridColumns<FieldModel>,
  }
}
